import { render } from "./rotate-device-horizontally.svg?vue&type=template&id=ae64d72a"
const script = {}
script.render = render

export default script